import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import {
  SectionFreeZoneBlock,
  SectionCaption,
  FreeZoneIcons,
  ServicePart,
  FZoneIcon,
  FZoneDetails,
} from './styles/FreeZoneService.styled';
import { ButtonDiv, Button } from './styles/Button.styled';

export default function FreezoneServices({ data, dir, id }) {
  return (
    <SectionFreeZoneBlock id={id}>
      <Container>
        <SectionCaption className="freezone_servicecap" dir={dir}>
          <h2 dir={dir}>{data.title}</h2>
          <p dir={dir}>{data.text}</p>
        </SectionCaption>
        <FreeZoneIcons className="freezone_icns">
          {data.servicesList.map(({ content }) => (
            <ServicePart className="service_part" dir={dir}>
              <FZoneIcon dir={dir}>
                <LazyLoadImage
                  src={content.image.url}
                  effect="blur"
                  placeholderSrc={
                    content.image.logo ? `${content.image.url}?width=50&quality=50` : null
                  }
                  width={48}
                  height={48}
                />
              </FZoneIcon>
              <FZoneDetails dir={dir}>
                <h3 dir={dir}>{content.title}</h3>
                <p dir={dir}>{content.subtitle}</p>
              </FZoneDetails>
            </ServicePart>
          ))}
        </FreeZoneIcons>

        <ButtonDiv className="btn_freezonecta">
          <Button stylevariant="red" href={data.link.url} target="_self" rel="" dir={dir}>
            {data.link.name}
          </Button>
        </ButtonDiv>
      </Container>
    </SectionFreeZoneBlock>
  );
}
